import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import { MenuItem } from "components/bootstrap";
import Menu from "components/bootstrap/Menu";
import StopPropagation from "views/components/common/StopPropagation";
import { widgetActionsDropdownOpenClass } from "views/components/widgets/Constants";
const Container = styled(StopPropagation)`
  display: inline-block;
  vertical-align: middle;
`;
const ActionDropdown = ({ children, element, "data-testid": dataTestid = void 0, header = "Actions" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleIsOpen = (newIsOpen) => setIsOpen(newIsOpen);
  return /* @__PURE__ */ React.createElement(Container, { "data-testid": dataTestid }, /* @__PURE__ */ React.createElement("span", { className: isOpen ? widgetActionsDropdownOpenClass : "" }, /* @__PURE__ */ React.createElement(Menu, { position: "bottom", withinPortal: true, onChange: toggleIsOpen }, /* @__PURE__ */ React.createElement(Menu.Target, null, element), /* @__PURE__ */ React.createElement(Menu.Dropdown, null, /* @__PURE__ */ React.createElement(MenuItem, { header: true }, header), children))));
};
export default ActionDropdown;
